import { mapOrder } from 'services/utilities'
import { actions } from './actions'

const initialState = {
  etiquetasUrl: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function etiquetaUrlReducer(state = initialState, action) {
  switch (action.type) {
    case actions.ETIQUETAS_URL_INSERT_REQUESTED:
      return {
        ...state,
        etiquetasUrl: { ...state.etiquetasUrl, loading: true, error: '' },
      }
    case actions.ETIQUETAS_URL_INSERT_SUCCEEDED:
      return {
        ...state,
        etiquetasUrl: {
          ...state.etiquetasUrl,
          data: [].concat(action.payload, state.etiquetasUrl.data),
          loading: false,
          error: '',
        },
      }
    case actions.ETIQUETAS_URL_INSERT_FILED:
      return {
        ...state,
        etiquetasUrl: { ...state.etiquetasUrl, loading: false, error: action.error },
      }

    case actions.ETIQUETA_URL_DELETE_REQUESTED:
      return {
        ...state,
        etiquetasUrl: { ...state.etiquetasUrl, loading: true, error: '' },
      }
    case actions.ETIQUETA_URL_DELETE_SUCCEEDED:
      return {
        ...state,
        etiquetasUrl: {
          ...state.etiquetasUrl,
          data: state.etiquetasUrl.data.filter(etiqueta => etiqueta.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.ETIQUETA_URL_DELETE_FILED:
      return {
        ...state,
        etiquetasUrl: { ...state.etiquetasUrl, loading: false, error: action.error },
      }
    case actions.ETIQUETAS_URL_UPDATE_REQUESTED:
      return {
        ...state,
        etiquetasUrl: { ...state.etiquetasUrl, loading: true, error: '' },
      }
    case actions.ETIQUETAS_URL_UPDATE_SUCCEEDED:
      return {
        ...state,
        etiquetasUrl: {
          ...state.etiquetasUrl,
          data: state.etiquetasUrl.data.map(etiqueta =>
            etiqueta.id === action.payload.id ? action.payload : etiqueta,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.ETIQUETAS_URL_UPDATE_FILED:
      return {
        ...state,
        etiquetasUrl: { ...state.etiquetasUrl, loading: false, error: action.error },
      }

    case actions.ETIQUETAS_URL_LOAD_REQUESTED:
      return { ...state, etiquetasUrl: { ...state.etiquetasUrl, loading: true } }
    case actions.ETIQUETAS_URL_LOAD_SUCCEEDED:
      return {
        ...state,
        etiquetasUrl: { ...state.etiquetasUrl, data: action.payload, loading: false },
      }
    case actions.ETIQUETAS_URL_LOAD_FILED:
      return {
        ...state,
        etiquetasUrl: { ...state.etiquetasUrl, data: null, loading: false, error: action.error },
      }
    case actions.ETIQUETAS_URL_SORT_UPDATE_REQUESTED:
      return {
        ...state,
        etiquetasUrl: {
          data: mapOrder(state.etiquetasUrl.data, action.payload, 'id'),
          loading: true,
        },
      }
    case actions.ETIQUETAS_URL_SORT_UPDATE_SUCCEEDED:
      return {
        ...state,
        etiquetasUrl: {
          data: mapOrder(state.etiquetasUrl.data, action.payload, 'id'),
          loading: false,
        },
      }
    case actions.ETIQUETAS_URL_SORT_UPDATE_FILED:
      return {
        ...state,
        etiquetasUrl: {
          ...state.etiquetasUrl,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
